import { render } from "./CardsView.vue?vue&type=template&id=4fc4082a&ts=true"
import script from "./CardsView.vue?vue&type=script&lang=ts"
export * from "./CardsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__